import { Map } from "immutable"

import {
    getList,
    getListCount,
    getItem,
    postItem,
    putItem,
    deleteItem
} from "./utils/entity-network-requests"

const entityName = "dimension"

// Dimension List
export const getDimensionList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getDimensionListCount = (token, parameters) =>
    getListCount(entityName, parameters, token)

// Dimension Entity
export const getDimensionItem = (token, id) => getItem(entityName, id, token)
export const getDimensionItemWithActiveTopics = (token, id) =>
    getItem(entityName, id, token, Map({ topic_statuses: "Active" }))
export const postDimensionItem = (token, dimension) =>
    postItem(entityName, dimension, token)
export const putDimensionItem = (token, id, dimension) =>
    putItem(entityName, id, dimension, token)

// Dimension Mappings
export const postDimensionPreviewMapping = (token, dimensionId, previewMapping) =>
    postItem(
        `${entityName}${dimensionId ? "/" + dimensionId : ""}/preview`,
        previewMapping,
        token
    )
export const deleteDimensionPreviewMapping = (token, dimensionId, mappingId) =>
    deleteItem(`${entityName}/${dimensionId}/preview`, mappingId, token)

// Dimension Reports
export const getDimensionReports = (token, dimensionId, parameters) =>
    getList(`${entityName}/${dimensionId}/report`, parameters, token)
